<template>
  <div class="tw:md:w-[570px] tw:md:max-w-[570px] tw:text-center tw:relative tw:h-full">
    <div
      class="tw:rounded-xl tw:px-5 tw:pt-8 tw:shadow-mdLg tw:relative tw:pb-6 tw:h-full tw:border-2"
      :class="{
        'tw:bg-blue-100 tw:border-blue-700': isSelected,
        'tw:border-transparent': !isSelected && !isRecommended,
        'tw:bg-white': !isSelected,
      }"
    >
      <div>
        <h5 class="tw:font-bold tw:text-2xl tw:mb-6 tw:px-6">{{ $t(campaignNameKey) }}</h5>
      </div>
      <p v-if="campaignType !== 'cpc'" class="tw:mb-1">
        {{ $t('rc_pay_per_stay_commission_header') }}
      </p>
      <p v-if="campaignType !== 'cpc'" class="tw:font-bold tw:text-xl">
        {{ commissions }}
      </p>
      <hr v-if="campaignType !== 'cpc'" class="tw:my-6 tw:h-px tw:border-none tw:bg-blue-300" />
      <div class="benefits-list" v-html="$t(campaignBenefitsKey)" />
      <small v-if="isCurrentlyActive" class="tw:block tw:text-sm tw:text-left tw:font-bold tw:mt-5 tw:text-blue-800">{{
        $t('rc_campaign_type_active')
      }}</small>
    </div>
    <div v-if="campaignType !== 'cpc'" class="tw:absolute tw:bottom-[-14px] tw:w-full">
      <span
        class="tw:py-1 tw:px-2 tw:bg-green-300 tw:border-4 tw:border-white tw:rounded-[100px] tw:text-green-700 tw:inline-flex tw:items-center tw:gap-1"
      >
        <CheckMark
          v-if="campaignType.toLowerCase() === 'netcpa'"
          height="10px"
          width="10px"
          class="tw:fill-green-700"
        />
        <small v-if="campaignType.toLowerCase() === 'netcpa'" class="tw:font-bold tw:text-xs tw:mr-1">{{
          $t('rc_upgrade_ncpa_highlight_1')
        }}</small>
        <CheckMark height="10px" width="10px" class="tw:fill-green-600" />
        <small class="tw:font-bold tw:text-xs tw:mr-1">
          {{ $t('rc_upgrade_ncpa_highlight_2') }}
        </small>
        <CheckMark height="10px" width="10px" class="tw:fill-green-600" />
        <small class="tw:font-bold tw:text-xs">
          {{ $t('rc_upgrade_ncpa_highlight_3') }}
        </small>
      </span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

import CheckMark from '@/components/icons/CheckMark.svg?component'

import { useCommissionLevels } from './queries'
import { useSessionValues } from '@/composables/useSessionValues'

const props = defineProps({
  isCurrentlyActive: {
    type: Boolean,
    default: false,
  },
  isRecommended: {
    type: Boolean,
    default: false,
  },
  isSelected: {
    type: Boolean,
    default: false,
  },
  campaignType: {
    type: String,
    default: 'netcpa',
    validator(value) {
      return ['netcpa', 'cpa', 'cpc'].includes(value)
    },
  },
})

const campaignNameKey = computed(() => {
  if (props.campaignType.toLowerCase() === 'netcpa') return 'rc_pay_per_stay'
  if (props.campaignType === 'cpa') return 'rc_pay_per_booking'
  return 'rc_pay_per_click'
})

const campaignBenefitsKey = computed(() => {
  if (props.campaignType.toLowerCase() === 'netcpa') return 'rc_pay_per_stay_campaign_benefits'
  if (props.campaignType === 'cpa') return 'rc_pay_per_booking_campaign_benefits'
  return 'rc_pay_per_click_campaign_benefits'
})

const { language } = useSessionValues()
const { eligibleCommissionLevels } = useCommissionLevels()
const commissions = computed(() => {
  if (!eligibleCommissionLevels.value) return
  return eligibleCommissionLevels.value
    ?.map(item =>
      new Intl.NumberFormat(language.value, {
        style: 'percent',
      }).format(item / 100)
    )
    .join(', ')
})
</script>

<style scoped>
.benefits-list :deep(ul) {
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  list-style-type: disc;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
</style>
